import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import classes from "./index.module.scss";

const LockIcon = () => (
  <LockOutlinedIcon className={classes.icon} />
);

export default LockIcon;
